import React from 'react';
import { observer } from 'mobx-react';

import { UiNavLink } from 'shared/uikit';
import { ROUTES } from 'shared/constants';

import { VmNotificationContentPropsType } from '../../types/VmNotificationContentPropsType';

type PropsType = VmNotificationContentPropsType;

export const VmNotificationTaskTrackerTaskDone = observer(({ notification, onClose }: PropsType) => {
    return (
        <div className={'vm-notification__content'}>
            <div className={'vm-notification__name'}>Задача завершена</div>
            <div className='vm-notification__description'>
                Задача была завершена <UiNavLink to={ROUTES.TASK_TRACKER_TASK(notification.data.task.id)} onClick={onClose}>[№{notification.data.task.id}] {notification.data.task.name}</UiNavLink>
            </div>
            <div className='vm-notification__additional'>
                {notification.data.task.responsibleUser && (
                    <div>
                        <label style={{ width: 95 }}>Исполнитель:</label>
                        <UiNavLink to={ROUTES.USER(notification.data.task.responsibleUserId)}>{notification.data.task.responsibleUser.previewName}</UiNavLink>
                    </div>
                )}
            </div>
        </div>
    );
});
